<template>
  <div class="print">
    <div class="table-responsive" style="margin-bottom: 200px">
      <table border="0" style="width: 100%; text-align: right">
        <tbody>
          <tr>
            <td align="left">
              <img src="/logo/logo_ori.png" height="100px;" />
            </td>
            <td width="200">
              <h4>
                <strong>
                  <u>FAKTUR PO</u>
                </strong>
              </h4>
              <table border="0" width="100%">
                <tr>
                  <td>Nomor</td>
                  <td>:</td>
                  <td align="left">{{ data.faktur }}</td>
                </tr>
                <tr>
                  <td>Tanggal</td>
                  <td>:</td>
                  <td align="left">{{ data.created_at | dateFormat }}</td>
                </tr>
                <tr>
                  <td>Admin</td>
                  <td>:</td>
                  <td align="left" v-if="data.user">{{ data.user.name }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        border="0"
        style="width: 100%; text-align: left"
        v-if="data.supplier"
      >
        <tbody>
          <tr>
            <td colspan="3">
              <b>Kepada Yth</b>
            </td>
          </tr>
          <tr>
            <td width="10%">Bapak/Ibu</td>
            <td width="1%">:</td>
            <td>{{ data.supplier.perusahaan }}</td>
          </tr>
          <tr>
            <td>Alamat</td>
            <td>:</td>
            <td>{{ data.supplier.address }}</td>
          </tr>
          <tr>
            <td>Telp</td>
            <td>:</td>
            <td>{{ data.supplier.phone }}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <div class="table-print">
        <table border="1" class="bordered" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Kode Barang</th>
              <th>Nama Barang</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, k) in data.purchase_details" :key="k">
              <td align="center">{{ k + 1 }}</td>
              <td>{{ d.item.code }}</td>
              <td>{{ d.item.name }}</td>
              <td align="right">{{ d.qty_real }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br />Note : {{ data.note }}
    </div>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
export default {
  data () {
    return {
      data: {}
    };
  },
  created () {
    const params = this.$route.params;
    const query = this.$route.query;
    if (params.id) {
      this.get(params.id);
    }
    if (!query.preview) {
      setTimeout(this.doPrint, 100);
    }
  },
  methods: {
    get (id) {
      HTTPAUTH.get("/api/v1/po/" + id + "/detail").then(res => {
        this.data = res.data.data;
      });
    },
    doPrint () {
      print();
      close();
    }
  }
};
</script>